import { render } from "./TrackMetadataTab.vue?vue&type=template&id=301ce48c&scoped=true"
import script from "./TrackMetadataTab.vue?vue&type=script&lang=js"
export * from "./TrackMetadataTab.vue?vue&type=script&lang=js"

import "./TrackMetadataTab.vue?vue&type=style&index=0&id=301ce48c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301ce48c"]])

export default __exports__